import { render } from "./IconArrowBack.vue?vue&type=template&id=26b0e560"
import script from "./IconArrowBack.vue?vue&type=script&lang=js"
export * from "./IconArrowBack.vue?vue&type=script&lang=js"

import exportComponent from "../../../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__